import { GlobalPositionStrategy } from "@angular/cdk/overlay";
import { AppConfigService } from "src/app/core";
import { AssistantBannerComponent } from "../components/banner/assistant-banner/assistant-banner.component";
import { AssistantPopupComponent } from "../components/popup/assistant-popup/assistant-popup.component";
import { AssistantUiComponent } from "./assistant-ui-component";
import { AssistantUiModel } from "./assistant-ui-model";

export class AssistantUiModelInstances {
  static Banner(appConfigService: AppConfigService): AssistantUiModel<AssistantUiComponent> {
    return {
      component: AssistantBannerComponent,
      positionStrategy: new GlobalPositionStrategy().bottom("0px").centerHorizontally(),
      maxHeight: "340px",
      width: "100%",
      minHeight: "176px",
      maxWidth: "1920px",
      allowMobile: true,
    };
  }

  static get Popup(): AssistantUiModel<AssistantUiComponent> {
    return {
      component: AssistantPopupComponent,
      positionStrategy: new GlobalPositionStrategy().bottom("10px").right("10px"),
      height: "460px",
      width: "320px",
      minWidth: "320px",
    };
  }
}
